import * as React from 'react';

import { ReportTypes } from '@showbie-socrative/socrative-utils';
import { translate } from '~l10n/client';

import { CommonProps, ExportReportPanel } from './ExportReportPanel';
import { IncludeExplanations, ReportOptionType } from './ReportOption';

const ExportReportsSummary = (props: CommonProps) => {
  const reportOptions: ReportOptionType[] = [IncludeExplanations];

  return (
    <ExportReportPanel
      {...props}
      shouldShowProBadgeInHeader={false}
      shouldShowProBadge={true}
      shouldShowPaywallOnReportsButtonClicked={false}
      reportOptions={reportOptions}
      initialOptions={props.initialOptions}
      title={translate('Results Summary PDF')}
      description={translate(
        'Export a PDF summarizing student responses and correct answers on a question-by-question basis.'
      )}
      reportRequestSelectedType={ReportTypes.QuestionSpecificPDF}
    />
  );
};

export { ExportReportsSummary };
export default ExportReportsSummary;
